import React, { useState, useEffect, useRef, useMemo } from "react";
import { loadModules } from "esri-loader";
import MasterPlanMap from "../../componets/MasterPlanMap";
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { useDispatch, useSelector } from "react-redux";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import * as XLSX from 'xlsx';
import { setIsBufferWidth, setIsSidebar } from "../../store/slice/currentStageSlice";
import { useNavigate } from "react-router-dom";
import "@arcgis/core/assets/esri/themes/light/main.css";

// import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";

import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";



const MASTER_PLAN_URL =
    "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";
const PROPERTY_URL =
    "https://urbangis.mp.gov.in/server/rest/services/Hosted/property_info_209/FeatureServer/1";
const ADMIN_LAYER_URL =
    "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";



function MapNewProperty2({
    isWidth, isByDefaultActive, isScreenSize
}) {
    // const [townOptions, setTownOptions] = useState([]);
    // const [landUseOptions, setLandUseOptions] = useState([]);
    const [selectedTown, setSelectedTown] = useState("");
    const [selectedLandUse, setSelectedLandUse] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [propertyFeatures, setPropertyFeatures] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [filteredCount, setFilteredCount] = useState({ title: "Property Type", value: 0 });
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage)

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [paginatedAllData, setPaginatedAllData] = useState([]); // New state for paginated 'All' data
    const [isTableView, setIsTableView] = useState(false);
    const [isTableMaximized, setIsTableMaximized] = useState(false);
    const [isAllData, setIsAllData] = useState([]);
    const [activeSelect, setActiveSelect] = useState(""); // Default to 'filter'
    const [isRelationId, setIsRelationId] = useState(); // Default to 'filter'
    const [view, setView] = useState(null);
    const [paginationTotal, setPaginationTotal] = useState({});
    const [paginationFilter, setPaginationFilter] = useState({});
    const legendWidgetRef = useRef(null);
    const navigate = useNavigate();

    const viewRef = useRef(null);
    const mapRef = useRef(null);
    const highlightLayerRef = useRef(null);
    const masterSubRef = useRef(null);
    const propertyLayerRef = useRef(null);
    const propertyLayerViewRef = useRef(null);

    const [towns, setTowns] = useState([]);
    const [townToUlb, setTownToUlb] = useState({});
    const [landUses, setLandUses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableFields, setTableFields] = useState([]);
    const [pagination, setPagination] = useState({ page: 0, totalPages: 0 });
    const unionGeomRef = useRef(null);


    const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
    const { currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
    const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
    const dispatch = useDispatch();
    const authData = useSelector(state => state.authToken.authData);

    console.log("authData", authData)

    // const townOptions = towns.map((town) => ({ label: town, value: town }));

    // Instead of only using towns state
    const townOptions = useMemo(() => {
        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
            // Fixed single option
            return [{ label: authData.UlbName, value: authData.UlbName }];
        } else {
            // Dynamic options for others
            return towns.map((town) => ({ label: town, value: town }));
        }
    }, [authData, towns]);





    const landUseOptions = landUses.map((lu) => ({ label: lu, value: lu }));
    const typeOptions = [
        { label: "All", value: "" },
        { label: "Residential", value: "Residential" },
        { label: "Commercial", value: "Commercial" },
        { label: "Mix Use", value: "Mix Use" },
        { label: "Govt Use", value: "Govt Use" },
        // Add more if needed
    ];

    useEffect(() => {
        if (authData) {
            if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                setSelectedTown(authData.UlbName);
                setTownToUlb({ [authData.UlbName]: authData.Ulb_Code });
                populateLandUseByTown(authData.UlbName)

            } else {
                populateTowns();
            }
        }
    }, [authData]);


    // 13SEP code for add new zoom method  on ULB


    const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

    useEffect(() => {
        if (!view) return;
        view.graphics.removeAll();
        zoomToUlb(selectedTown.toUpperCase());
    }, [view, authData]);



    const zoomToUlb = async (town) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/5')}` });
        const query = new Query({ where: `name = '${town}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };




    // code for add new zoom method on UL


    useEffect(() => {
        // Initialize map and layers
        // const map = new Map({ basemap: "topo-vector" });
        const map = new Map({ basemap: "satellite" });
        const view = new MapView({
            container: mapRef.current,
            map,
            center: [77.4, 23.25],
            zoom: 6,
            ui: { components: ["attribution"] }
        });



        viewRef.current = view;
        setView(view)

        // 17sep View clear 

        view.when(() => {
            console.log("View is ready");

            // ✅ CLICK EVENT TO REMOVE GRAPHICS
            view.on("click", async (event) => {
                console.log("Map clicked");
                view.graphics.removeAll();  // This should clear your graphics
            });

            // You can also call ZOOMTOProperty() here or set up UI events
        });


        //17sep View clear 








        // view.ui.add(new Search({ view: view }), "top-left");
        view.ui.add(new Home({ view: view }), "top-right");
        // view.ui.add(new Zoom({ view: view }), "top-left");
        view.ui.add(new Expand({ view: view, content: new BasemapGallery({ view: view }) }), "top-right");
        view.ui.add(new Locate({ view: view, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-right");
        view.ui.add(new ScaleBar({ view: view }), "bottom-right");

        //  legend  layerList

        const layerList = new LayerList({
            view: view
        });

        const expand = new Expand({
            view: view,
            content: layerList,
            expanded: false
        });

        view.ui.add(expand, "top-right");


        // code  end  for legend  

        view.when(() => {
            const printWidget = new Print({
                view: view,
                printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });

            const expandPrint = new Expand({
                view: view,
                content: printWidget
            });


            // ✅ Add and attach legend
            const legendWidget = new Legend({
                view: view,
                style: "classic"
            });

            const legendExpand = new Expand({
                view: view,
                content: legendWidget,
                expanded: false
            });

            view.ui.add(legendExpand, "top-right");
            legendWidgetRef.current = legendWidget;
            view.ui.add(expandPrint, "top-right");

        });




        const masterMIL = new MapImageLayer({ url: MASTER_PLAN_URL });
        map.add(masterMIL);

        masterMIL.when(() => {
            const masterSub = masterMIL.findSublayerById(3);
            if (masterSub) {
                masterSub.definitionExpression = "1=0";
                masterSubRef.current = masterSub;
            }
        });

        view.graphics.removeAll();

        const propertyLayer = new FeatureLayer({
            url: PROPERTY_URL,
            outFields: ["*"],
            visible: true,
            definitionExpression: "1=0",

            popupEnabled: true,
            popupTemplate: {
                title: "Property ID: {relation_id}",
                content: [


                    {
                        type: "fields",
                        fieldInfos: [
                            { fieldName: "gis_uniqueid", label: "Gis Unique ID" },
                            { fieldName: "ownername", label: "Owner Name" },
                            { fieldName: "mobileno", label: "Mobile No" },
                            { fieldName: "e_nagarpalikaid", label: "E Nagarpalika ID" },
                            { fieldName: "landusetype", label: "Landuse Type" },
                        ]
                    },
                    {
                        type: "media",
                        mediaInfos: [
                            {
                                title: "<b>Property Photo</b>",
                                type: "image",
                                caption: "Linked to Relation ID",
                                value: {
                                    sourceURL:
                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                }
                            }
                        ]
                    },
                    {
                        type: "text",
                        text: `
    <div style="max-height: 300px; overflow-y: auto;">
      <div style="margin-bottom: 10px;">
        <b></b><br>
        <img 
          src="" 
          alt="" 
          style="width: 000px; height: 600px; border: 1px solid #ccc; margin-top: 5px;" 
        /><br>
        <i>Linked to Relation ID: {relation_id}</i>
      </div>

      
    </div>
  `
                    }




                ]
            }//poptype close

        });


        // view.graphics.removeAll();
        map.add(propertyLayer);
        propertyLayerRef.current = propertyLayer;

        view.whenLayerView(propertyLayer).then((lv) => {
            view.graphics.removeAll();
            propertyLayerViewRef.current = lv;
        });

        const adminLayer = new MapImageLayer({
            url: ADMIN_LAYER_URL,
            title: "Administrative Boundaries",
            sublayers: [{ id: 1, visible: true }, { id: 3, visible: true }],
        });
        map.add(adminLayer);

        populateTowns();

        return () => {
            if (view) {
                view.container = null;
            }
        };
    }, []);




    async function populateTowns() {
        const fl = new FeatureLayer({ url: MASTER_PLAN_URL + "/3" });
        const q = fl.createQuery();
        q.where = "1=1";
        q.outFields = ["town_name", "ulb_cd"];
        const res = await fl.queryFeatures(q);

        const seen = new Set();
        const townsList = [];
        const townUlbMap = {};

        res.features.forEach((f) => {
            const town = f.attributes.town_name;
            const ulb = f.attributes.ulb_cd;
            if (town && ulb && !seen.has(town)) {
                townsList.push(town);
                townUlbMap[town] = ulb;
                seen.add(town);
            }
        });

        setTowns(townsList);
        setTownToUlb(townUlbMap);
    }

    async function populateLandUseByTown(town) {
        setLandUses([]);
        if (!town) return;

        const fl = new FeatureLayer({ url: MASTER_PLAN_URL + "/3" });
        const q = fl.createQuery();

        // q.where = `town_name='${town}'`;
        q.where = `UPPER(town_name)='${town.toUpperCase()}'`;
        q.outFields = ["land_use"];
        const res = await fl.queryFeatures(q);

        const seen = new Set();
        const landUseList = [];
        res.features.forEach((f) => {
            const val = f.attributes.land_use;
            if (val && !seen.has(val)) {
                landUseList.push(val);
                seen.add(val);
            }
        });
        setLandUses(landUseList);
    }

    useEffect(() => {
        if (!selectedTown) {
            if (masterSubRef.current) masterSubRef.current.definitionExpression = "1=0";
            if (propertyLayerRef.current) propertyLayerRef.current.definitionExpression = "1=0";
            setLandUses([]);
            setSelectedLandUse("");
            setTotalCount(null);
            setFilteredCount(null);
            setTableData([]);
            setPagination({ page: 0, totalPages: 0 });
            unionGeomRef.current = null;
            return;
        }

        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
            // populateLandUseByTown(authData.UlbName);
        } else {
            populateLandUseByTown(selectedTown);
        }



        if (masterSubRef.current) masterSubRef.current.definitionExpression = `town_name='${selectedTown.toUpperCase()}'`;

        (async () => {
            const fl = new FeatureLayer({ url: MASTER_PLAN_URL + "/3" });
            const q = fl.createQuery();
            q.where = `town_name='${selectedTown.toUpperCase()}'`;
            const result = await fl.queryExtent(q);
            if (result.extent) {
                viewRef.current.goTo(result.extent.expand(1.2));
            }
        })();

        if (propertyLayerRef.current) {
            const ulb = townToUlb[selectedTown];
            propertyLayerRef.current.definitionExpression = `ulb_cd='${ulb}'`;
        }
    }, [selectedTown, townToUlb, authData]);

    useEffect(() => {
        if (!selectedTown) return;
        let expr = `town_name='${selectedTown.toUpperCase()}'`;
        if (selectedLandUse) expr += ` AND land_use='${selectedLandUse}'`;
        if (masterSubRef.current) masterSubRef.current.definitionExpression = expr;
    }, [selectedLandUse, selectedTown, authData]);

    useEffect(() => {
        if (!selectedTown) return;
        const ulb = townToUlb[selectedTown];
        let expr = `ulb_cd='${ulb}'`;
        if (selectedType) expr += ` AND landusetype='${selectedType}'`;
        if (propertyLayerRef.current) {
            propertyLayerRef.current.definitionExpression = expr;
        }
        if (propertyLayerViewRef.current && unionGeomRef.current) {
            propertyLayerViewRef.current.filter = { geometry: unionGeomRef.current, where: expr };
        }
    }, [selectedType, selectedTown, townToUlb, authData]);

    async function runIntersect() {
        setLoading(true);
        if (!selectedTown) {
            setLoading(false);
            return;
        }
        console.log("selectedTownselectedTown", selectedTown)

        let ulb;
        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
            ulb = authData?.Ulb_Code;

        } else {
            ulb = townToUlb[selectedTown];
        }
        console.log("ulbulb", ulb)
        console.log("townToUlb", townToUlb)
        const fl = new FeatureLayer({ url: MASTER_PLAN_URL + "/3" });
        const q = fl.createQuery();
        q.where = `town_name='${selectedTown.toUpperCase()}'${selectedLandUse ? ` AND land_use='${selectedLandUse}'` : ""}`;

        q.returnGeometry = true;

        const mpFS = await fl.queryFeatures(q);
        if (mpFS.features.length === 0) {
            setTotalCount(null);
            setFilteredCount(null);
            setTableData([]);
            setPagination({ page: 0, totalPages: 0 });
            setLoading(false);
            return;
        }

        const unionGeom =
            mpFS.features.length > 1
                ? geometryEngine.union(mpFS.features.map((f) => f.geometry))
                : mpFS.features[0].geometry;
        unionGeomRef.current = unionGeom;

        console.log("unionGeomunionGeom", unionGeom)

        let mpWhere = `town_name='${selectedTown.toUpperCase()}'`;
        if (selectedLandUse) mpWhere += ` AND land_use='${selectedLandUse}'`;
        if (masterSubRef.current) masterSubRef.current.definitionExpression = mpWhere;

        const totalQuery = propertyLayerRef.current.createQuery();
        totalQuery.geometry = unionGeom;
        totalQuery.spatialRelationship = "intersects";
        totalQuery.where = `ulb_cd='${ulb}'`;
        const totalCountResult = await propertyLayerRef.current.queryFeatureCount(totalQuery);
        console.log("totalCountResult", totalCountResult)

        let propWhere = `ulb_cd='${ulb}'`;
        if (selectedType) propWhere += ` AND landusetype='${selectedType}'`;

        if (propertyLayerRef.current) {
            propertyLayerRef.current.definitionExpression = propWhere;
        }
        if (propertyLayerViewRef.current) {
            propertyLayerViewRef.current.filter = { geometry: unionGeom, where: propWhere };
        }

        const filteredQuery = propertyLayerRef.current.createQuery();
        filteredQuery.geometry = unionGeom;
        filteredQuery.spatialRelationship = "intersects";
        filteredQuery.where = propWhere;
        const filteredCountResult = await propertyLayerRef.current.queryFeatureCount(filteredQuery);


        setTotalCount(totalCountResult);
        setFilteredCount({
            title: selectedType ? `${selectedType} Properties` : "Filtered Properties",
            value: filteredCountResult
        });


        // Load both datasets initially
        await renderTablePaged("total", `ulb_cd='${ulb}'`, unionGeom, 0, totalCountResult);
        await renderTablePaged("filter", propWhere, unionGeom, 0, filteredCountResult);
        setActiveSelect("total");
        setTotalRecords(totalCountResult); // Set initial total records for the Paginator

        setActiveSelect("total"); // Ensure 'total' is active when runIntersect completes

        viewRef.current.goTo(unionGeom.extent.expand(1.2));
        setLoading(false);
    }


    // async function renderTablePaged(where, geom, page, totalCountResult) {
    //     const query = propertyLayerRef.current.createQuery();
    //     query.where = where;
    //     query.geometry = geom;
    //     query.spatialRelationship = "intersects";
    //     query.outFields = ["*"];
    //     query.returnGeometry = false;
    //     query.start = page * rows;
    //     query.num = rows;

    //     const res = await propertyLayerRef.current.queryFeatures(query);
    //     const tableRows = res.features.map((f) => f.attributes);

    //     setPaginatedAllData(tableRows);
    //     setIsTableView(true);
    //     setTotalRecords(totalCountResult);

    //     // ✅ Save total pagination state
    //     setPaginationTotal({
    //         where,
    //         geom,
    //         totalCountResult
    //     });
    // }
    async function renderTablePaged(mode, where, geom, page, totalCount) {
        const query = propertyLayerRef.current.createQuery();
        query.where = where;
        query.geometry = geom;
        query.spatialRelationship = "intersects";
        query.outFields = ["*"];
        query.returnGeometry = false;
        query.start = page * rows;
        query.num = rows;

        const res = await propertyLayerRef.current.queryFeatures(query);
        const tableRows = res.features.map(f => f.attributes);

        if (mode === "total") {
            setPaginatedAllData(tableRows);
            setPaginationTotal({ where, geom, totalCount });
        } else {
            setFilteredPropertyData(tableRows);
            setPaginationFilter({ where, geom, totalCount });
        }

        setIsTableView(true);
        setTotalRecords(totalCount);
    }


    async function renderTablePaged2(where, geom, page, filteredCountResult) {
        const query = propertyLayerRef.current.createQuery();
        query.where = where;
        query.geometry = geom;
        query.spatialRelationship = "intersects";
        query.outFields = ["*"];
        query.returnGeometry = false;
        query.start = page * rows;
        query.num = rows;

        const res = await propertyLayerRef.current.queryFeatures(query);
        const tableRows = res.features.map((f) => f.attributes);

        setFilteredPropertyData(tableRows);
        setIsTableView(true);
        setTotalRecords(filteredCountResult);
        setActiveSelect("filter")

        // ✅ Save filtered pagination state
        setPaginationFilter({
            where,
            geom,
            filteredCountResult
        });
    }


    console.log("setFilteredPropertyData", filteredPropertyData)




    function reset() {
        if (masterSubRef.current) masterSubRef.current.definitionExpression = "1=0";
        if (propertyLayerRef.current) propertyLayerRef.current.definitionExpression = "1=0";
        setSelectedTown("");
        setSelectedLandUse("");
        setSelectedType("");
        setLandUses([]);
        setTotalCount(null);
        setFilteredCount(null);
        setTableData([]);
        setTableFields([]);
        setPagination({ page: 0, totalPages: 0 });
        unionGeomRef.current = null;
    }


    useEffect(() => {
        if (selectedLandUse && !loading || authData?.UserType === "districtuser" || authData?.UserType === "User") {
            runIntersect();
        } else if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
            runIntersect();
        }
    }, [selectedLandUse, selectedType, authData]);


    // my code




    const stats = [
        {
            value: totalCount ?? "-",
            title: `Property within Master Plan ${selectedLandUse || ""} Land Use`
        },
        {
            value: filteredCount && typeof filteredCount === "object" ? filteredCount.value : filteredCount ?? "-",
            title: filteredCount && typeof filteredCount === "object" ? filteredCount.title : "Filtered Properties"
        }
    ];


    const onPageChangePrimeReact = (event) => {
        const newFirst = event.first;
        const newRows = event.rows;
        setFirst(newFirst);
        setRows(newRows);

        const newPage = newFirst / newRows;

        if (activeSelect === "total" && paginationTotal.where && paginationTotal.geom) {
            renderTablePaged("total", paginationTotal.where, paginationTotal.geom, newPage, paginationTotal.totalCount);
        } else if (activeSelect === "filter" && paginationFilter.where && paginationFilter.geom) {
            renderTablePaged("filter", paginationFilter.where, paginationFilter.geom, newPage, paginationFilter.totalCount);
        }
    };

    const onRowsChangePrimeReact = (newRowsValue) => { // Renamed parameter to avoid conflict with state variable
        setRows(newRowsValue);
        setFirst(0); // Reset to first page when rows per page changes

        if (activeSelect === "total" && paginationTotal.where && paginationTotal.geom) {
            renderTablePaged("total", paginationTotal.where, paginationTotal.geom, 0, paginationTotal.totalCount);
        } else if (activeSelect === "filter" && paginationFilter.where && paginationFilter.geom) {
            renderTablePaged("filter", paginationFilter.where, paginationFilter.geom, 0, paginationFilter.totalCount);
        }
    };


    const getTableColumns = () => {
        const dataToUse = activeSelect === "total" ? paginatedAllData : filteredPropertyData;
        if (!dataToUse || dataToUse.length === 0) return [];

        const firstFeatureAttributes = dataToUse[0];

        const hiddenKeys = [
            "objectid", "divisionname", "districtname", "dist_cd", "div_cd", "parcelno", "wardno",
            "electricity_id", "globalid", "shape", "shape_length", "shape_area", "ihtoiletk", "ihtoiletyn",
            "wstyofusedetails", "propertyno", "ulbtype", "photolink", "isuseres", "swmd2d", "swmd2dby",
            "swmd2ddetails", "remark", "singlepage", "wssldia", "wsmunconn", "wsconnno", "wsconncount",
            "vlandarea", "ulbname", "ulb_cd", "situationdetails", "taxzonename_e", "constructionyear",
            "relation_id", "shape__length", "shape__area"
        ];

        return Object.keys(firstFeatureAttributes)
            .filter(key => !hiddenKeys.includes(key.toLowerCase()))
            .map(key => ({
                field: key,
                header: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())
            }));
    };


    const columns = getTableColumns();



    const toggleTableMaximize = () => {
        setIsTableMaximized(!isTableMaximized);
    };

    const handleNotificationClick = (rowId) => {

        setIsRelationId(rowId?.relation_id)
        handleRowClick(rowId?.relation_id)


    };

    //Code for 17sep 


    const handleRowClick = async (relationId) => {
        view.graphics.removeAll();
        //alert(`relationId : ${relationId}`);
        ZOOMTOProperty(relationId);
    };


    const ZOOMTOProperty = async (relationId) => {
        const layer = new FeatureLayer({ url: PROPERTY_URL });
        const query = new Query({
            where: `relation_id='${relationId}'`,
            returnGeometry: true
        });

        try {
            // Remove existing graphics before adding new one
            view.graphics.removeAll();

            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [98, 252, 251, 0.5], // LightSkyBlue with 50% opacity
                        outline: {
                            color: [98, 252, 251],
                            width: 3.0
                        }
                    },
                    popupEnabled: true,
                    popupTemplate: {
                        title: "Property ID: {relation_id}",
                        content: [


                            {
                                type: "fields",
                                fieldInfos: [
                                    { fieldName: "gis_uniqueid", label: "Gis Unique ID" },
                                    { fieldName: "ownername", label: "Owner Name" },
                                    { fieldName: "mobileno", label: "Mobile No" },
                                    { fieldName: "e_nagarpalikaid", label: "E Nagarpalika ID" },
                                    { fieldName: "landusetype", label: "Landuse Type" },
                                ]
                            },
                            {
                                type: "media",
                                mediaInfos: [
                                    {
                                        title: "<b>Property Photo</b>",
                                        type: "image",
                                        caption: "Linked to Relation ID",
                                        value: {
                                            sourceURL:
                                                "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                        }
                                    }
                                ]
                            },
                            {
                                type: "text",
                                text: `
    <div style="max-height: 300px; overflow-y: auto;">
      <div style="margin-bottom: 10px;">
        <b></b><br>
        <img 
          src="" 
          alt="" 
          style="width: 000px; height: 600px; border: 1px solid #ccc; margin-top: 5px;" 
        /><br>
        <i>Linked to Relation ID: {relation_id}</i>
      </div>      
    </div>
  `
                            }]
                    }//poptype close

                });

                view.graphics.add(graphic);

                // Zoom to the selected feature
                await view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to property:", error);
        }
    };





    const downloadExcel = () => {
        const dataToExport = activeSelect === "total" ? paginatedAllData : filteredPropertyData;

        if (!dataToExport || dataToExport.length === 0) {
            return;
        }

        try {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const colWidths = Object.keys(dataToExport[0]).map(key => ({
                wch: Math.max(
                    key.toString().length,
                    ...dataToExport.map(row => row[key] ? row[key].toString().length : 0)
                )
            }));
            ws['!cols'] = colWidths;

            const wb = XLSX.utils.book_new();
            let sheetName = activeSelect === "total" ? "All Properties" : `${selectedType || "Filtered"} Properties`;
            XLSX.utils.book_append_sheet(wb, ws, sheetName.substring(0, 30));

            let fileName = `Property_Data_${selectedTown || "All"}_${selectedLandUse || "All"}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            fileName = fileName.replace(/[^a-zA-Z0-9_\-\.]/g, "_");

            XLSX.writeFile(wb, fileName);

        } catch (error) {
            console.error("Error exporting to Excel:", error);
            alert("Error exporting data. Please try again.");
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsScreenSize1(window.innerWidth <= 991)
        };
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const handleToggleBufferWidth = () => {
        dispatch(setIsBufferWidth(!isBufferWidth));
    };
    const handleToggleBufferLeft = () => {
        dispatch(setIsSidebar(!isSideBar));
    };


    const calculatedHeight = useMemo(() => {
        const hasFeatureTableData = setFeatureTable?.length > 0;
        if (isWidth && isByDefaultActive) {
            return "calc(100vh - 78px)"; // Adjust height as needed
        }


        if (isWidth) {
            return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
        }
        if (isWidth) {
            return "calc(100vh - 78px)"
        }
        if (!isWidth && hasFeatureTableData) {
            return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
        }
        if (!isWidth && hasFeatureTableData && isByDefaultActive) {
            return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
        }
        if (!isToolHeight && isTableView) {
            return "calc(100vh - 455px)"
        }

        if (isToolHeight && isTableView) {
            return "calc(100vh - 360px)"
        }

        if (!isToolHeight) {
            return "calc(100vh - 210px)"
        }
        return "calc(100vh - 109px)";
    }, [isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight, isTableView]);


    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        if (!selectedTown || !unionGeomRef.current) return;

        setFirst(0); // Reset to first page when switching tabs

        if (activeSelect === "total" && paginationTotal.where && paginationTotal.geom) {
            renderTablePaged(
                "total",
                paginationTotal.where,
                paginationTotal.geom,
                0, // Always load the first page when switching tabs
                paginationTotal.totalCount
            );
            setTotalRecords(paginationTotal.totalCount); // <--- Add this
        } else if (activeSelect === "filter" && paginationFilter.where && paginationFilter.geom) {
            renderTablePaged(
                "filter",
                paginationFilter.where,
                paginationFilter.geom,
                0, // Always load the first page when switching tabs
                paginationFilter.totalCount
            );
            setTotalRecords(paginationFilter.totalCount); // <--- Add this
        }
    }, [activeSelect, selectedTown, unionGeomRef.current]);




    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2'>
            {!isTableMaximized && (
                <div className='row'>
                    <div className={isBufferWidth ? 'col-md-12 p-0 h-100' : "col-md-9 p-0 h-100"}>
                        <div className="position-relative">
                            <div ref={mapRef}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    height: calculatedHeight,
                                    // height: "450px",
                                    // border: "4px solid #f39945ff",
                                    borderRadius: "4px"
                                }}

                            ></div>

                            {currentStageValue === 0 ? "" :
                                <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
                                    <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
                                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                                    </div>
                                </div>
                            }
                            {currentStageValue === 0 ? "" :
                                <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
                                >
                                    <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
                                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                                    </div>
                                </div>
                            }

                        </div>

                        {/* <div className="tabs-container">
                            <button className={`tab-btn ${activeSelect === "total" ? "active" : ""}`} onClick={() => setActiveSelect("total")}>Total Properties</button>
                            {selectedType && (
                                <button className={`tab-btn ${activeSelect === "filter" ? "active" : ""}`} onClick={() => setActiveSelect("filter")} >{selectedType} Properties</button>
                            )}
                        </div> */}


                    </div>
                    {!isBufferWidth && (
                        <div className='col-md-3 p-0 h-100'>
                            <div className='px-2 h-100 d-flex flex-column'>
                                <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                    <h6 className='sidebarbuttontitle text-white m-0'>Master Plan Land use Based Properties Explore</h6>
                                    {/* <button className='btn text-white no-hover'
                                        onClick={() => navigate("/link-dashboard")}
                                    >Back</button> */}
                                </div>

                                {/* <div className='scroll-layerdiv flex-grow-1' style={{ overflowY: 'auto' }}> */}
                                <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                                    <div>
                                        <h5 className="sidebarbuttontitle mt-3 mb-1 text-black">
                                            Select Town </h5>

                                        <Select
                                            options={townOptions}
                                            value={townOptions.find((opt) => opt.value === selectedTown) || null}
                                            onChange={(opt) => setSelectedTown(opt?.value || "")}
                                            placeholder="Select Town"
                                            isClearable
                                            styles={customStyles}

                                        />
                                    </div>


                                    {/* <label style={{ marginBottom: 10 }}>
                                        <div style={{ fontWeight: "bold" }}>Master Plan Landuse:</div>   </label> */}
                                    <div>
                                        <h5 className="sidebarbuttontitle mt-3 mb-1 text-black">
                                            Master Plan Land Use </h5>
                                        <Select
                                            options={landUseOptions}
                                            value={landUseOptions.find((opt) => opt.value === selectedLandUse) || null}
                                            onChange={(opt) => setSelectedLandUse(opt?.value || "")}
                                            placeholder="Select Landuse"
                                            isClearable
                                            styles={customStyles}
                                        />
                                    </div>


                                    {/* <label style={{ marginBottom: 20 }}>
                                        <div style={{ fontWeight: "bold" }}>Property Use:</div>  </label> */}
                                    <div>
                                        <h5 className="sidebarbuttontitle mt-3 mb-1 text-black">
                                            Select Property Type </h5>

                                        <Select
                                            options={typeOptions}
                                            value={typeOptions.find((opt) => opt.value === selectedType) || null}
                                            onChange={(opt) => setSelectedType(opt?.value || "")}
                                            placeholder="Select Landuse Type"
                                            styles={customStyles}

                                        />
                                    </div>




                                    {/* <button className="btn-refresh2" onClick={handleReset} style={{ marginTop: "14px" }}>
                                        <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {isTableView && (
                <div
                    className="bg-white border-top"
                >
                    <div className="d-flex justify-content-between align-items-center py-1">
                        <div className="tabs-container">
                            <button className={`tab-btn ${activeSelect === "total" ? "active" : ""}`} onClick={() => setActiveSelect("total")}>Total Properties</button>
                            {selectedType && (
                                <button className={`tab-btn ${activeSelect === "filter" ? "active" : ""}`} onClick={() => setActiveSelect("filter")} >{selectedType} Properties</button>
                            )}
                        </div>

                        <div className="d-flex gap-2">

                            <button className='gradient-btn' onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>

                            <button
                                className="btn p-0 btn-titles btn-titlesdiv"
                                onClick={toggleTableMaximize}
                            >
                                {isTableMaximized ? (
                                    <>
                                        <img src="img/expand-icon.svg" alt='Maximise Panel' /> Minimize
                                    </>
                                ) : (
                                    <>
                                        <img src="img/expand-icon.svg" alt='Maximise Panel' /> Maximize
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        {!isTableMaximized && (
                            <div className="col-md-4">
                                {selectedTown && selectedLandUse && (
                                    <div className="row mt-3">
                                        {stats.map((s, idx) => (
                                            <div className="col-md-6 mt-2" key={idx} style={{ cursor: 'pointer' }}>
                                                <div className={`property-card-${idx} text-center active-card-identified}`} style={{ height: "150px" }}>
                                                    <div className=''><h3 className="m-0 property-card-id-title">{s.value}</h3></div>
                                                    <h4 className="property-card-id-text m-0">{s.title}</h4>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                        <div className={isTableMaximized ? "col-md-12" : "col-md-8"}>
                            <div className='table-wrapper flex-grow-1 position-relative table-indentify' >

                                <DataTable
                                    value={activeSelect === "total" ? paginatedAllData : filteredPropertyData}
                                    scrollable
                                    scrollHeight={
                                        isTableMaximized
                                            ? (isToolHeight ? "calc(100vh - 200px)" : "calc(100vh - 300px)")
                                            : (isToolHeight ? "160px" : "150px")
                                    }
                                    style={{ minWidth: "10rem", width: "100%" }}
                                    loading={isTableLoading}
                                    emptyMessage="No data found"
                                    resizableColumns
                                    columnResizeMode="expand"
                                >
                                    <Column
                                        header="S.No"
                                        body={(data, options) => first + options.rowIndex + 1}
                                        style={{ minWidth: "80px", textAlign: "center" }}
                                    />
                                    <Column
                                        header=""
                                        body={(rowData) => (
                                            <button
                                                className="btn btn-sm btn-outline-primary p-1"
                                                onClick={() => handleNotificationClick(rowData)}
                                            >
                                                Zoom To
                                            </button>
                                        )}
                                        style={{ textAlign: "center", minWidth: "120px" }}
                                    />

                                    {columns.map((col) => (
                                        <Column
                                            key={col.field}
                                            field={col.field}
                                            header={col.header}
                                            sortable
                                            style={{ minWidth: '150px', maxWidth: '250px' }}  // limit column width
                                            headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                            bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                            body={(rowData) => (
                                                <span
                                                    title={rowData[col.field]}  // full text on hover
                                                    className="truncate-text"
                                                    type="button"
                                                >
                                                    {rowData[col.field]}
                                                </span>
                                            )}
                                        // style={{
                                        //     whiteSpace: "nowrap",
                                        //     overflow: "hidden",
                                        //     textOverflow: "ellipsis",
                                        //     minWidth:
                                        //         col.field === "floor_details"
                                        //             ? "600px"
                                        //             : ["mobileno", "plotsize", "plintharea", "nooffloor", "ta_builtuparea", "ptaxno"].includes(col.field)
                                        //                 ? "100px"
                                        //                 : "250px",
                                        // }}
                                        // body={(rowData) => (
                                        //     <span title={rowData[col.field]}>
                                        //         {rowData[col.field]}
                                        //     </span>
                                        // )}
                                        />
                                    ))}


                                </DataTable>

                                {totalRecords > 0 && (
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        rowsPerPageOptions={[100, 200, 500, 2000]}
                                        onPageChange={onPageChangePrimeReact}
                                        template={{
                                            layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                            RowsPerPageDropdown: (options) => {
                                                const dropdownOptions = [
                                                    { label: 100, value: 100 },
                                                    { label: 200, value: 200 },
                                                    { label: 500, value: 500 },
                                                    { label: 2000, value: 2000 },
                                                ];
                                                return (
                                                    <select
                                                        value={rows}
                                                        onChange={(e) => onRowsChangePrimeReact(Number(e.target.value))}
                                                        style={{
                                                            padding: "0",
                                                            borderRadius: "3px",
                                                            border: "1px solid #ced4da",
                                                        }}
                                                    >
                                                        {dropdownOptions.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                );
                                            },
                                        }}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                        style={{
                                            position: "sticky",
                                            bottom: 0,
                                            backgroundColor: "#e6fffa",
                                            padding: "0.5rem",
                                            borderTop: "1px solid #dee2e6",
                                            zIndex: 10,
                                        }}
                                    />
                                )}


                            </div>
                        </div>
                    </div>


                </div>
            )}
        </div>
    );
}

export default MapNewProperty2;